import { network } from 'services/network';

export const createUserGroup = (params) => {
    return network.post('admin/bo/createUserGroup', params).then((response) => response.data);
};
